import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import { withRouter } from 'react-router-dom'
import { actions } from '../../../redux/modules/reports/maintenance_dob/stopCallsReportActions'
import { DatePicker, Button, Form, Checkbox, AutoComplete, Input, Icon, Spin } from 'antd'
import moment from 'moment'
import _ from 'lodash'
import { convertToOption } from '../../../util'
import ListItems from '../../../components/reports/maintenance_dob/stop-calls/ListItems'
import queryString from 'qs'
import config from '../../../config'

const { API_BASE } = config

const { RangePicker } = DatePicker

const propTypes = {}
const FormItem = Form.Item
const CheckboxGroup = Checkbox.Group

class StopCallsContainer extends Component {
  constructor(props) {
    super(props)
    const filter = [
      moment(new Date(), 'YYYY-MM-DD').startOf('month'),
      moment(new Date(), 'YYYY-MM-DD').endOf('month')
    ]
    this.state = {
      filter: filter,
      indeterminate: false,
      checkedList: [],
      checkAll: false,
      plainOptions: ['All', 'Open', 'Completed'],
      selectedJobId: 0,
      selectedJobName: ''
    }

    // get job list
    this.props.stopCallsReportGetJobList()
    // get organization list
    this.props.stopCallsReportGetOrganizationList()
  }

  onChange = (date, dateString) => {
    this.setState({
      filter: dateString
    })
  }

  onChangeCheckboxGroup = checkedList => {
    this.setState({
      checkedList,
      indeterminate: !!checkedList.length && checkedList.length < this.state.plainOptions.length,
      checkAll: checkedList.length === this.state.plainOptions.length
    })
  }

  applyFilter = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      values.job_id = this.state.selectedJobId

      this.props.stopCallsReportGetFullReport({ filters: values })
    })
  }

  onCheckAllChange = e => {
    const { form } = this.props
    form.setFieldsValue({
      statuses: e.target.checked ? this.state.plainOptions : []
    })
    this.setState({
      checkedList: e.target.checked ? this.state.plainOptions : [],
      indeterminate: false,
      checkAll: e.target.checked
    })
  }

  printReport = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      const params = _.omit(values, 'date_range')

      if (values.date_range[0] && values.date_range[1]) {
        params.startDate = moment(values.date_range[0]).format('YYYY-MM-DD')
        params.endDate = moment(values.date_range[1]).format('YYYY-MM-DD')
      }

      if (this.state.selectedJobId && this.state.selectedJobId != 0) {
        params.job_id = this.state.selectedJobId
      }

      const qs = queryString.stringify(params)
      const url = `${API_BASE}/api/reports/maintenance-dob/stop-calls-report/print?${qs}`
      window.open(url, '_blank')
    })
  }

  _handleSearch = query => {
    const searchOnItems = async query => {
      const items = convertToOption(
        this.props.stopCallsReportActions.jobList
          ? this.props.stopCallsReportActions.jobList.data
          : []
      )
      const foundItems = items.filter(
        item => item.text.toLowerCase().indexOf(query.toLowerCase()) !== -1
      )
      return foundItems
    }

    searchOnItems(query).then(options => {
      this.setState({
        options
      })
    })
  }

  handleAddItemInputSelect = value => {
    if (value.length > 0) {
      let selectedId = value[0].value
      const selectedItem = this.props.stopCallsReportActions.jobList.data.filter(
        row => parseInt(row.id, 0) === selectedId
      )
      if (selectedItem.length > 0) {
        this.setState({
          selectedJobId: selectedId,
          selectedJobName: selectedItem[0].name
        })
      } else {
        this.setState({
          selectedJobId: null
        })
      }
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form

    const jobListData = _.get(this.props, 'stopCallsReportActions.jobList.data')
    const loadingJobList = _.get(this.props, 'stopCallsReportActions.loadingJobList')

    const organizationListData = _.get(this.props, 'stopCallsReportActions.organizationList.data')
    const loadingOrganizationList = _.get(
      this.props,
      'stopCallsReportActions.loadingOrganizationList'
    )

    const loadingFullReport = _.get(this.props, 'stopCallsReportActions.loadingFullReport')
    const fullReport = _.get(this.props, 'stopCallsReportActions.fullReport.data')
    return (
      <div style={{ marginTop: 20, marginBottom: 20 }}>
        <div className="row">
          <div className="col-10">
            <h3>Stop Calls Report</h3>
          </div>
          <Button icon="printer" onClick={() => this.printReport()} />
        </div>
        <Form layout="vertical">
          <div className="row">
            <div className="col-6">
              <div className="row">
                <div className="col-12">
                  <FormItem label="Select the date range:">
                    {getFieldDecorator('date_range', {
                      rules: [
                        {
                          required: true,
                          message: 'You must enter a first name'
                        }
                      ],
                      initialValue: this.state.filter
                    })(<RangePicker onChange={this.onChange} />)}
                  </FormItem>
                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  <Spin spinning={loadingJobList}>
                    <FormItem label="Job">
                      <AsyncTypeahead
                        ref="typeahead"
                        id="typeAheadInput"
                        delay={200}
                        labelKey="text"
                        isLoading={loadingJobList}
                        options={convertToOption(jobListData)}
                        minLength={1}
                        onSearch={this._handleSearch}
                        placeholder="Search for a Job"
                        onChange={selected => {
                          this.handleAddItemInputSelect(selected)
                        }}
                        onInputChange={value =>
                          this.setState({
                            selectedJobId: null
                          })
                        }
                      />
                    </FormItem>
                  </Spin>
                </div>
                <div className="col-6">
                  <Spin spinning={loadingOrganizationList}>
                    <FormItem label="Company">
                      {getFieldDecorator('company_id', {})(
                        <AutoComplete
                          dataSource={convertToOption(organizationListData)}
                          filterOption={(inputValue, option) =>
                            option.props.children
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                          placeholder="Search for a Company"
                        >
                          <Input
                            suffix={<Icon type="search" className="certain-category-icon" />}
                          />
                        </AutoComplete>
                      )}
                    </FormItem>
                  </Spin>
                </div>
              </div>
            </div>
            <div className="col-6">
              <FormItem label="Sstatuses:">
                {getFieldDecorator('statuses', {
                  initialValue: this.state.checkedList
                })(
                  <CheckboxGroup
                    options={this.state.plainOptions}
                    onChange={this.onChangeCheckboxGroup}
                    className="open-container-row"
                  />
                )}
              </FormItem>
              <div style={{ borderTop: '1px solid #E9E9E9' }}>
                <Checkbox
                  indeterminate={false}
                  onChange={this.onCheckAllChange}
                  checked={this.state.checkAll}
                >
                  Check all
                </Checkbox>
              </div>
            </div>
          </div>
          <Button type="primary" onClick={() => this.applyFilter()}>
            Submit
          </Button>
        </Form>
        <div className="row" style={{ marginTop: 20, marginBottom: 20 }}>
          <div className="col-12">
            <ListItems fullReport={fullReport} loadingFullReport={loadingFullReport} />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ stopCallsReportActions, authentication }, ownProps) => ({
  stopCallsReportActions,
  authentication
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions), dispatch)
})

StopCallsContainer.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(StopCallsContainer))
)



// WEBPACK FOOTER //
// ./src/containers/reports/maintenance_dob/StopCallsReportContainer.js